import {useCallback} from 'react';

import {getMonitorLifecycleTexts, useMonitorToggle} from 'entities/monitor';
import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import IHttpMonitorOutput from './HttpMonitor/IHttpMonitor';

export const useHttpMonitorToggle = (
    item: Pick<IHttpMonitorOutput, 'uuid' | 'status'>,
    onLimit: () => void,
) => {
    const [startHttpMonitor] = httpMonitorAPI.useStartHttpMonitorMutation();
    const [stopHttpMonitor] = httpMonitorAPI.useStopHttpMonitorMutation();
    const texts = getMonitorLifecycleTexts();

    return useMonitorToggle({
        isActive: item.status === 'active',
        isPaused: item.status === 'paused',
        pause: () => stopHttpMonitor(item.uuid).unwrap(),
        resume: () => startHttpMonitor(item.uuid).unwrap(),
        pausedText: texts.paused,
        resumedText: texts.resumed,
        onLimit,
        onClick: useCallback(() => reachGoal(YM_GOALS.PAUSE_MONITOR), []),
    });
};

export default useHttpMonitorToggle;
